export enum ConfigGroupKey {
  REGISTRATION_FIELD_DISPLAY_CONFIG = "REGISTRATION_FIELD_DISPLAY_CONFIG",
  CUSTOMER_CARE_FIELD_DISPLAY_CONFIG = "CUSTOMER_CARE_FIELD_DISPLAY_CONFIG",
}
